module.exports = __webpack_public_path__ + "img/logo-primary.82463676.svg";